import React, { useState, useEffect, useRef, useCallback } from 'react';
import AnimatedContent from "../Common/AnimatedContent";
import 'animate.css';
import { ImExit } from "react-icons/im";
import { VscWorkspaceTrusted } from "react-icons/vsc";
import { motion } from "framer-motion";
import { useInView } from 'react-intersection-observer';
import { FaSalesforce } from "react-icons/fa";
import { MdSupportAgent } from "react-icons/md";
import { GiGrowth } from "react-icons/gi";
import { FaComputer } from "react-icons/fa6";
import { GrMultiple } from "react-icons/gr";

const About = () => {
    const howcosworks = useRef(null);
    const cardRefs = useRef([]);
    const [visibleCards, setVisibleCards] = useState([]);

    useEffect(() => {
        if (window.location.hash === '#howcosworks') {
            howcosworks.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);

    const observerCallback = useCallback((entries) => {
        entries.forEach((entry, index) => {
            if (entry.isIntersecting) {
                setVisibleCards((prev) => [...new Set([...prev, index])]);
            }
        });
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(observerCallback, { threshold: 0.2 });

        cardRefs.current.forEach((card, index) => {
            if (card) observer.observe(card);
        });

        return () => observer.disconnect();
    }, [observerCallback]);

    const textVariants = {
        hidden: { opacity: 0, x: -10 },
        visible: (i) => ({
            opacity: 1,
            x: 0,
            transition: { delay: i * 0.05, duration: 0.3, ease: "easeOut" },
        }),
    };

    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });

    const text = "Why Choose CoOwnSpace?";
    const characters = text.split("");

    const cardData = [
        {
            icon: < VscWorkspaceTrusted  />,
            title: "Trusted Partnerships",
            description:
                "CoOwnSpace is built on strong, reliable partnerships, ensuring long-term success for our partners and clients alike.",
        },
        {
            icon:<GrMultiple/>,
            title: "Unlimited Sales Potential",
            description:
                "With access to a wide range of high-demand real estate opportunities, CoOwnSpace empowers you to unlock your full sales potential and drive growth.",
        },
        {
            icon: <GiGrowth/>,
            title: "Growth Opportunities",
            description:
                "Whether you're an experienced professional or new to the industry, we provide a dynamic environment where you can thrive and elevate your sales game.",
        },
        {
            icon:"icon-money",
            title: "Incentive-Driven Success",
            description:
                "Our rewarding structure and exciting incentives are designed to boost earnings, keep you motivated, and fuel consistent sales performance.",
        },
        {
            icon: <FaComputer />,
            title: "Innovative Platform",
            description:
                "CoOwnSpace provides a cutting-edge platform that streamlines real estate transactions, enhances client satisfaction, and opens the door to more sales opportunities.",
        },
        {
            icon: <MdSupportAgent />,
            title: "Dedicated Support",
            description:
                "Our team is committed to helping you close deals and achieve your sales goals with ongoing training, resources, and guidance.",
        }

    ];

    return (
        <section ref={howcosworks} id='howcosworks' className="section-help tf-spacing-1 ">
            <div className="tf-container">
                <div className="row">
                    <div className="col-12">
                        <div className="heading-section text-center">
                            <h2 ref={ref} className="title balance text-h2 ">
                                {characters.map((char, i) => (
                                    <motion.span
                                        key={i}
                                        className="inline-block "
                                        variants={textVariants}
                                        initial="hidden"
                                        animate={inView ? "visible" : "hidden"}
                                        custom={i}
                                    >
                                        {char}
                                    </motion.span>
                                ))}
                            </h2>
                            <AnimatedContent
                                distance={5}
                                direction="vertical"
                                reverse={false}
                                config={{ tension: 80, friction: 20 }}
                                initialOpacity={0.2}
                                animateOpacity
                                scale={1.1}
                                threshold={0.2}
                            >
                                {/* <p className="text-1 animate__fadeInUp animate__animated">
                                    We simplify real estate investment by offering fractional ownership across a wide range of properties.
                                </p> */}
                            </AnimatedContent>
                        </div>

                        <div className="tf-grid-layout md-col-2 mb-6">
                            {cardData.map((card, index) => (
                                <div
                                    key={index}
                                    ref={(el) => (cardRefs.current[index] = el)}
                                    className={`icons-box style-3 icon-direction ${
                                        visibleCards.includes(index) ? "animate__animated animate__zoomIn" : ""
                                    }`}
                                >
                                    <div className="tf-icon">
                                        {typeof card.icon === "string" ? <i className={card.icon}></i> : card.icon}
                                    </div>
                                    <div className="content">
                                        <h3 className="title text-h3">{card.title}</h3>
                                        <p className="text-0">{card.description}</p>
                                        {/* <a href="" className="tf-btn-link color-3">
                                         <span>Learn More</span>
                                        </a> */}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="item text-center p-5">
            </div>
        </section>
    );
};

export default About;
